import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Scrollbar, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';

export class FlexibleSlider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-flexible-slider');
    if (this.sliders.length === 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.swiper.autoplay.start();
          } else {
            entry.target.swiper.autoplay.stop();
          }
        });
      },
      { root: null, threshold: 0, rootMargin: `0px 0px` },
    );

    this.sliders.forEach((slider) => {
      this.initSlider(slider);
    });
  }

  initSlider(slider) {
    const options = {
      modules: [Pagination, Navigation, Autoplay, Scrollbar, FreeMode],
      slidesPerView: 'auto',
      grabCursor: true,
    };

    const container = slider.closest('.js-flexible-slider-container') || slider.parentNode;
    const buttonNext = container.querySelector('.js-slider-button.-next');
    const buttonPrev = container.querySelector('.js-slider-button.-prev');
    const progressbar = container.querySelector('.js-slider-progressbar');
    const scrollbar = container.querySelector('.js-slider-scrollbar');
    const pagination = container.querySelector('.js-slider-pagination');
    const fraction = container.querySelector('.js-slider-fraction');

    const totalSlides = slider.querySelectorAll('.swiper-slide').length;

    if (buttonNext && buttonPrev) {
      options.navigation = {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      };
    }

    if (progressbar) {
      options.pagination = {
        el: progressbar,
        type: 'progressbar',
        clickable: true,
      };
    }

    if (scrollbar) {
      options.scrollbar = {
        el: scrollbar,
        draggable: true,
      };
    }

    if (pagination) {
      options.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true,
      };
    }

    if (slider.classList.contains('-autoplay')) {
      const delayData = slider.getAttribute('data-delay');
      options.autoplay = {
        delay: delayData || 5000,
        disableOnInteraction: false,
      };
    }

    if (slider.classList.contains('-loop')) {
      options.loop = true;
      options.loopAdditionalSlides = 2;
      options.initialSlide = totalSlides;
      options.on = {
        init: function (swiper) {
          swiper.slideToLoop(totalSlides, 0);
        },
      };
      this.cloneSlide(slider);
    }

    if (slider.classList.contains('-free')) {
      options.freeMode = {
        enabled: true,
      };
    }

    if (slider.classList.contains('-center')) {
      options.centeredSlides = true;
      options.normalizeSlideIndex = false;
    }

    // if (slider.classList.contains('-img-height')) {
    //   this.getImgHeight(slider, container);
    // }

    const swiper = new Swiper(slider, options);

    if (slider.classList.contains('-autoplay')) {
      this.observer.observe(swiper.el);
    }

    if (fraction) {
      this.updateFraction(swiper, fraction, totalSlides);

      swiper.on('slideChange', () => {
        this.updateFraction(swiper, fraction, totalSlides);
      });
    }
  }

  // getImgHeight(slider, container) {
  //   const targetSlide = slider.querySelectorAll('.swiper-slide')[0];
  //   const imgHeight = targetSlide.querySelector('img').offsetHeight;

  //   container.style.setProperty('--img-height', `${imgHeight}px`);
  // }

  cloneSlide(slider) {
    const slides = slider.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
      const cloneSlide = slide.cloneNode(true);
      slider.querySelector('.swiper-wrapper').appendChild(cloneSlide);
    });
  }

  updateFraction(swiper, fraction, totalSlides) {
    let currentIndex = swiper.realIndex + 1;
    if (currentIndex > totalSlides) {
      currentIndex = currentIndex - totalSlides;
    }
    fraction.setAttribute('data-current', currentIndex);
    fraction.setAttribute('data-total', totalSlides);
  }

  resize() {
    let timer = 0;
    this.resizeObserver = new ResizeObserver((entries) => {
      if (timer > 0) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.sliders.forEach((slider) => {
          let isAct = true;
          if (slider.classList.contains('-tab') && window.innerWidth >= 1024) {
            isAct = false;
          } else if (slider.classList.contains('-sp') && window.innerWidth >= 768) {
            isAct = false;
          }
          if (isAct === true && !slider.swiper) {
            this.initSwiper(slider);
          }
          if (isAct === false && slider.swiper) {
            slider.swiper.destroy();
          }
        });
      }, 100);
    });
    this.resizeObserver.observe(document.body);
  }
}
